import DatePicker from 'react-datepicker';
import classNames from '../../../layout/classNames';
import React, {useState} from 'react';
import {useForecastingSettings} from '../../ForecastingContextProvider';
import {DateRangeStatus, usePrimaryForecastingState} from '../ForecastingPanel';
import './DateRange.css';

function isValidDate(date: Date|null) {
    return date != null && !isNaN(date.getTime());
}
function isValidRange(start: Date|null, end: Date|null): boolean {
     return isValidDate(start) && isValidDate(end) && start! <= end!;

}

function ParseAndSetDash(dash:string) {
    if (dash.indexOf(' - ') != -1) return ' - ';
    if (dash.indexOf(' -') != -1) return ' -';
    if (dash.indexOf('- ') != -1) return '- ';
    if (dash.indexOf('-') != -1) return '-';
    if (dash.indexOf(' ') != -1) return '';
    return '';
}

function GetTodayDate() {
    var today = new Date();
    today.setHours(0,0,0,0);
    return today;
}

function getEndOfDayDate (date: Date | null) {
    date?.setHours(23, 0, 0, 0);
    return date;
}

export default function DateRange() {
    const { forecastingSettings, updateForecastingSetting } = useForecastingSettings();
    const { isPrimaryForecastingLoading, inputDateRangeStatus, setInputDateRangeStatus } = usePrimaryForecastingState();

    const [ startDateVis, setStartDateVis ] = useState(forecastingSettings.dateRange[0] != null ? new Date(forecastingSettings.dateRange[0]).toLocaleDateString('en-US') : '');
    const [ endDateVis, setEndDateVis ] = useState(forecastingSettings.dateRange[1] != null ? new Date(forecastingSettings.dateRange[1]).toLocaleDateString('en-US') : '');
    const [ dash , setDash] = useState(' - ');
    
    return (
        <div className='mt-4 w-80'>
            <label
                htmlFor='dateRange'
                className='block text-sm font-medium text-gray-700'
            >
                Date range
            </label>
            <DatePicker
                selectsRange={true}
                minDate = {new Date()}
                startDate={
                    forecastingSettings.dateRange[0] != null
                        ? new Date(forecastingSettings.dateRange[0])
                        : null
                }
                endDate={
                    forecastingSettings.dateRange[1] != null
                        ? new Date(forecastingSettings.dateRange[1])
                        : null
                }
                onChange={(update) => {
                    const endDate = getEndOfDayDate(update[1]);
                    setDash(' - ');
                    setStartDateVis(update[0]?.toLocaleDateString('en-US') ?? '');
                    setEndDateVis(endDate?.toLocaleDateString('en-US') ?? '');
                    updateForecastingSetting({ dateRange: [
                        update[0]?.toISOString() ?? null,
                        endDate?.toISOString() ?? null
                    ]});
                    setInputDateRangeStatus(DateRangeStatus.Valid);
                }}
                onChangeRaw={(update) => {
                    if (update.target.type == 'text') {
                        var dateArrayParsed = update.target.value
                            .split('-', 2)
                            .map(s => s.trim());
                        setDash(ParseAndSetDash(update.target.value));
                        setStartDateVis(dateArrayParsed[0] ??  '');
                        setEndDateVis(dateArrayParsed[1]  ?? '');
                    }
                }}
                onBlur={(update) =>{
                    const start =  new Date(startDateVis);
                    const end =  new Date(endDateVis);

                    //on enter have dash be set back if there's some input
                    if (isValidDate(start) && isValidDate(end)) setDash(' - ');
                    if (isValidRange(start!, end!)) {
                        updateForecastingSetting({
                            dateRange: [
                                start!.toISOString(),
                                end!.toISOString()
                            ]
                        });
                        setInputDateRangeStatus(start >= GetTodayDate() ? DateRangeStatus.Valid : DateRangeStatus.PastDate);
                    }
                    //set null
                    else {
                        updateForecastingSetting({dateRange: [null, null]});
                        setInputDateRangeStatus(DateRangeStatus.Malformed);
                    }
                }}
                value={startDateVis + dash + endDateVis}
                monthsShown={2}
                disabled={isPrimaryForecastingLoading}
                disabledKeyboardNavigation
                placeholderText='MM/DD/YYYY - MM/DD/YYYY'
                className={classNames(
                    'mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm text-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500',
                    isPrimaryForecastingLoading && 'cursor-not-allowed opacity-50',
                    inputDateRangeStatus == DateRangeStatus.Valid ? 'border-gray-300' : 'border-red-300'
                )}
            />
        </div>
    );
}
